import {
  Flex,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
} from '@chakra-ui/react';
import { FC } from 'react';
import { ResumoDeMidia } from '../models';

interface Props {
  resumo: ResumoDeMidia | null;
}

const Cartao: FC<{
  titulo: string;
  valor: string;
  detalhe: string;
  destaque?: boolean;
}> = ({ titulo, valor, detalhe, destaque = false }) => (
  <Stat
    bg="white"
    p={5}
    borderRadius="12px"
    border="1px solid"
    borderColor={destaque ? 'red.300' : '#E2EEFF'}
  >
    <StatLabel color="gray.600">{titulo}</StatLabel>
    <StatNumber color={destaque ? 'red.500' : '#469BFF'}>{valor}</StatNumber>
    <StatHelpText mb={0}>{detalhe}</StatHelpText>
  </Stat>
);

const ResumoCards: FC<Props> = ({ resumo }) => (
  <Flex gap={4} mb={8} flexWrap="wrap">
    <Cartao
      titulo="Em uso"
      valor={resumo ? String(resumo.emUso.quantidade) : '—'}
      detalhe={
        resumo
          ? `${resumo.emUso.mbTotal.toLocaleString('pt-BR')} MB no total`
          : ''
      }
    />
    <Cartao
      titulo={`Acima de ${resumo?.limiteKb ?? 300} KB`}
      valor={resumo ? String(resumo.emUso.acimaDoLimite) : '—'}
      detalhe="imagens em uso para reexportar"
      destaque={!!resumo && resumo.emUso.acimaDoLimite > 0}
    />
    <Cartao
      titulo="Não usadas"
      valor={resumo ? String(resumo.naoUsados.quantidade) : '—'}
      detalhe={
        resumo
          ? `${resumo.naoUsados.mbTotal.toLocaleString('pt-BR')} MB no total`
          : ''
      }
    />
  </Flex>
);

export default ResumoCards;
